import { SharedProps } from '@/types'
import { Head, usePage } from '@inertiajs/react'
import { Paper, Stack, Text, Title } from '@mantine/core'

export default function UserEditPage() {
  const { props } = usePage<SharedProps>()
  const user = props.current_user

  return (
    <>
      <Head title="Mon compte" />
      <div style={{ padding: 'var(--mantine-spacing-xl)' }}>
        <Title order={1} mb="lg">
          Mon compte
        </Title>
        <Paper shadow="sm" p="xl" radius="md" withBorder mb="lg">
          <Stack gap="sm">
            <div>
              <Text fw={500} span>
                ID:
              </Text>{' '}
              <Text span>#{user?.id}</Text>
            </div>
            <div>
              <Text fw={500} span>
                Email:
              </Text>{' '}
              <Text span>{user?.email}</Text>
            </div>
          </Stack>
        </Paper>
      </div>
    </>
  )
}
